import React from 'react'
import ListItem from '@material-ui/core/ListItem'
import LanguageSelector from '~components/molecules/LanguageSelector/LanguageSelector'
import HeaderItem from './HeaderItem'
import HeaderUserItem from './HeaderUserItem'
import HeaderSwitchApp from './HeaderSwitchApp'
import Link from 'shared-ui/components/Link'

const HeaderVersionItem = ({ version }) => (
  <Link
    to="/version"
    className="rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium shadow-sm transition hover:bg-gray-50"
  >
    v{version}
  </Link>
)

const components = {
  HeaderItem,
  HeaderUserItem,
  HeaderSwitchApp,
  HeaderVersionItem,
}

const wrapInListItem = (Component, wrapIt) =>
  wrapIt ? <ListItem>{Component}</ListItem> : Component

class CommonHeaderItems extends React.Component {
  render() {
    const { items = [], member, wrapAsListItem, itemClass, width } = this.props

    // Sort items so HeaderSwitchApp is last
    const sortedItems = [...items].sort((a, b) => {
      return a.component === 'HeaderSwitchApp' ? 1 : b.component === 'HeaderSwitchApp' ? -1 : 0
    })

    const filteredItems =
      (wrapAsListItem
        ? sortedItems?.filter(item => item.component !== 'HeaderSwitchApp')
        : sortedItems) || []

    return (
      <React.Fragment>
        {width !== 'xs' &&
          wrapInListItem(<LanguageSelector className={itemClass} />, wrapAsListItem)}

        {filteredItems.map(({ component, props, data }, index) => {
          const Component = components[component]
          return wrapInListItem(
            <Component key={'item_' + index} {...props} member={member} className={itemClass} />,
            wrapAsListItem,
          )
        })}
      </React.Fragment>
    )
  }
}

export default CommonHeaderItems
